import PhysicalWorldFormDTO from './PhysicalWorldFormDTO'

class PhysicalWorldManager {
  list = []

  constructor (list = []) {
    this.list = list
  }

  getList () {
    return this.list
  }

  setList (list) {
    this.list = list
  }

  get () {
    return this.getList()
  }

  makeCommonBodyToRequest (requestData) {
    const {
      recipient: { name, email, phone },
      address,
      open_hours,
      observation
    } = requestData

    const phoneData = {
      country_code: '55',
      area_code: phone.slice(0, 2),
      number: phone.slice(2)
    }

    return {
      recipient: {
        name,
        email,
        phones: {
          home_phone: phoneData,
          mobile_phone: phoneData
        },
        location: {
          address: { ...address, reference: address.complement },
          open_hours
        }
      },
      observation
    }
  }

  makeBodyToRequestTerminal () {
    const requestData = new PhysicalWorldFormDTO().get()

    return {
      ...this.makeCommonBodyToRequest(requestData),
      type: 'install'
    }
  }

  makeBodyToRequestTerminalRoll () {
    const { kit_quantity, ...requestData } = new PhysicalWorldFormDTO().get()

    return {
      ...this.makeCommonBodyToRequest(requestData),
      type: 'supply',
      kit_quantity
    }
  }

  makeBodyToRequestUninstallTerminal () {
    const { serialNumber, ...requestData } = new PhysicalWorldFormDTO().get()

    return {
      ...this.makeCommonBodyToRequest(requestData),
      type: 'uninstall',
      serial_number: serialNumber
    }
  }

  makeBodyToRequestSwapTerminal () {
    const { serialNumber, ...requestData } = new PhysicalWorldFormDTO().get()

    return {
      ...this.makeCommonBodyToRequest(requestData),
      type: 'swap',
      serial_number: serialNumber
    }
  }
}

export default PhysicalWorldManager
